import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { ViewComponent } from 'src/app/core/view/view.component';
import { ViewsService } from 'src/app/core/view/views.service';
import { ContactsService } from 'src/app/organizations/organizations-detail/organizations-contacts-detail/contacts.service';
import { OrganizationsContactsDetailComponent } from 'src/app/organizations/organizations-detail/organizations-contacts-detail/organizations-contacts-detail.component';

@Component({
  selector: 'app-contacts-list',
  templateUrl: './contacts-list.component.html',
  styleUrls: ['./contacts-list.component.scss']
})
export class ContactsListComponent implements OnInit {
  @ViewChild("view") public view: ViewComponent;
  public contactsFilters: any = {};

  constructor(
    private contactsService: ContactsService,
    private viewsService: ViewsService,
    private coreDialogService: CoreDialogService,
    private messageService: MessageService,
    private dialogService: DialogService,
    private router: Router,
  ) { }

  ngOnInit(): void {
  }
  viewContact(contact) {
    this.router.navigate(["/contacts/" + (contact ? contact.id : 0)]);

    /*
    const ref = this.dialogService.open(OrganizationsContactsDetailComponent, {
      data: {
        contactId: contact ? contact.id : 0,
      },
      //header: contact ? "Detalles del contacto" : "Nuevo contacto",
      width: '70%',
    });
    ref.onClose.subscribe((data: any) => {
      if (typeof (this.view) !== "undefined") this.viewsService.changeView(this.view.code);
      this.view.fireEvent("contacts.list.results", "reload");
    });*/
  }
  deleteContact(contact) {
    this.coreDialogService.confirm({
      message: "¿Quieres borrar el contacto " + contact.name + "?",
      header: "Confirmación de borrado",
      icon: "pi pi-info-circle",
      accept: () => {
        this.contactsService.delete(contact.id).subscribe(
          data => {
            this.messageService.add({ closable: false, severity: 'success', detail: "Borrado correctamente" });
            this.router.navigate(['/contacts']);
            this.view.fireEvent("contacts.list.results", "reload");
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        )
      },
      reject: () => { }
    });
  }
  onEvent(event: any) {
    if (event.component == "contacts.list.filters") {
      if (event.event == "action" && event.action.name == "search") this.view.fireEvent("contacts.list.results", "reload");
    } else if (event.component == "contacts.list.results") {
      if (event.event == "dblclick") this.viewContact(event.data);
      if (event.event == "action" && event.action.name == "add") this.viewContact(null);
      if (event.event == "action" && event.action.name == "edit") this.viewContact(event.data);
      if (event.event == "action" && event.action.name == "delete") this.deleteContact(event.data);
    }
  }
}
